var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', [_c('sub-visual', {
    attrs: {
      "sh": "Alliance",
      "bg": "/images/sub/visual/sv4.jpg"
    }
  }), _c('section', {
    staticClass: "section section--first pb-0"
  }, [_c('v-container', [_c('div', {
    staticClass: "tit-wrap"
  }, [_c('h2', {
    staticClass: "tit tit--lg dot-tit"
  }, [_vm._v(" Alliance ")])]), _c('div', {
    directives: [{
      name: "scroll",
      rawName: "v-scroll",
      value: _vm.onScrollFixed,
      expression: "onScrollFixed"
    }],
    staticClass: "scroll-fixed-tab w-100"
  }, [_c('scrollactive', {
    staticClass: "my-nav v-tabs v-tab--primary",
    attrs: {
      "offset": _vm.$vuetify.breakpoint.lgAndUp ? 177 : 102,
      "scrollOffset": _vm.$vuetify.breakpoint.lgAndUp ? 177 : 102,
      "highlightFirstItem": true,
      "active-class": "v-tab--active"
    }
  }, [_c('router-link', {
    staticClass: "scrollactive-item v-tab",
    attrs: {
      "to": "#abb"
    }
  }, [_vm._v("ABB")]), _c('router-link', {
    staticClass: "scrollactive-item v-tab",
    attrs: {
      "to": "#teledyne"
    }
  }, [_vm._v("TELEDYNE")]), _c('router-link', {
    staticClass: "scrollactive-item v-tab",
    attrs: {
      "to": "#pac"
    }
  }, [_vm._v("PAC")]), _c('router-link', {
    staticClass: "scrollactive-item v-tab",
    attrs: {
      "to": "#metal"
    }
  }, [_vm._v("METAL SAMPLES")]), _c('router-link', {
    staticClass: "scrollactive-item v-tab",
    attrs: {
      "to": "#extrel"
    }
  }, [_vm._v("EXTREL")])], 1)], 1)])], 1), _c('section', {
    staticClass: "section pt-0",
    attrs: {
      "id": "abb"
    }
  }, [_c('v-container', [_c('top-image', {
    attrs: {
      "tit": "ABB",
      "bgImage": "/images/sub/alliance/abb-bg.jpg",
      "image": "/images/sub/alliance/abb-img.jpg"
    }
  }, [_c('p', {
    staticClass: "page-text mb-6 mb-lg-20"
  }, [_vm._v("1,000’s of solutions for all of your challenges Analytical Measurement made "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v("easy from A-Z.")]), _c('p', {
    staticClass: "page-text"
  }, [_vm._v(" Solutions and turnkey provider trusted partner for your Business. ")]), _c('div', {
    staticClass: "mt-30 mt-md-60 mt-lg-80"
  }, [_c('v-btn', {
    staticClass: "justify-space-between",
    attrs: {
      "outlined": "",
      "tile": "",
      "width": "180",
      "color": "primary",
      "href": "https://global.abb/group/en",
      "target": "_blank"
    }
  }, [_c('span', [_vm._v("Web site")]), _c('v-icon', {
    attrs: {
      "size": "16"
    }
  }, [_vm._v("mdi-open-in-new")])], 1)], 1)])], 1)], 1), _c('section', {
    staticClass: "section pt-0",
    attrs: {
      "id": "teledyne"
    }
  }, [_c('v-container', [_c('top-image', {
    attrs: {
      "tit": "TELEDYNE",
      "bgImage": "/images/sub/alliance/teledyne-bg.jpg",
      "image": "/images/sub/alliance/teledyne-img.jpg"
    }
  }, [_c('p', {
    staticClass: "page-text"
  }, [_vm._v("Teledyne provides enabling technologies to sense, transmit and analyze information for industrial growth markets. These markets include aerospace and defense, factory automation, air and water quality environmental monitoring, electronics design and development, oceanographic research, energy, medical imaging and pharmaceutical research.")]), _c('div', {
    staticClass: "mt-30 mt-md-60 mt-lg-80"
  }, [_c('v-btn', {
    staticClass: "justify-space-between",
    attrs: {
      "outlined": "",
      "tile": "",
      "width": "180",
      "color": "primary",
      "href": "https://www.teledyne-ai.com/",
      "target": "_blank"
    }
  }, [_c('span', [_vm._v("Web site")]), _c('v-icon', {
    attrs: {
      "size": "16"
    }
  }, [_vm._v("mdi-open-in-new")])], 1)], 1)])], 1)], 1), _c('section', {
    staticClass: "section pt-0",
    attrs: {
      "id": "pac"
    }
  }, [_c('v-container', [_c('top-image', {
    attrs: {
      "tit": "PAC",
      "bgImage": "/images/sub/alliance/pac-bg.jpg",
      "image": "/images/sub/alliance/pac-img.jpg"
    }
  }, [_c('p', {
    staticClass: "page-text"
  }, [_vm._v("PAC is a leading global manufacturer of advanced Analytical instruments for "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v("laboratories and online process applications in industries such as "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v("petrochemical, refinery, upstream, biofuels, environmental, food & beverage, "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v("lubricants, automotive and pharmaceutical.")]), _c('div', {
    staticClass: "mt-30 mt-md-60 mt-lg-80"
  }, [_c('v-btn', {
    staticClass: "justify-space-between",
    attrs: {
      "outlined": "",
      "tile": "",
      "width": "180",
      "color": "primary",
      "href": "https://www.paclp.com/",
      "target": "_blank"
    }
  }, [_c('span', [_vm._v("Web site")]), _c('v-icon', {
    attrs: {
      "size": "16"
    }
  }, [_vm._v("mdi-open-in-new")])], 1)], 1)])], 1)], 1), _c('section', {
    staticClass: "section section--last pt-0",
    attrs: {
      "id": "metal"
    }
  }, [_c('v-container', [_c('top-image', {
    attrs: {
      "tit": "Metal Samples",
      "bgImage": "/images/sub/alliance/metal-bg.jpg",
      "image": "/images/sub/alliance/metal-img.jpg"
    }
  }, [_c('p', {
    staticClass: "page-text"
  }, [_vm._v("Metal Samples specializes in manufacturing products for corrosion monitoring "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v("& materials evaluation. Since 1980 we have supplied products and services to "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v("chemical processing, water treating, and petroleum industries around the world.")]), _c('div', {
    staticClass: "mt-30 mt-md-60 mt-lg-80"
  }, [_c('v-btn', {
    staticClass: "justify-space-between",
    attrs: {
      "outlined": "",
      "tile": "",
      "width": "180",
      "color": "primary",
      "href": "https://www.alspi.com/",
      "target": "_blank"
    }
  }, [_c('span', [_vm._v("Web site")]), _c('v-icon', {
    attrs: {
      "size": "16"
    }
  }, [_vm._v("mdi-open-in-new")])], 1)], 1)])], 1)], 1), _c('section', {
    staticClass: "section section--last pt-0",
    attrs: {
      "id": "extrel"
    }
  }, [_c('v-container', [_c('top-image', {
    attrs: {
      "tit": "EXTREL",
      "bgImage": "/images/sub/alliance/extrel-bg.jpg",
      "image": "/images/sub/alliance/extrel-img.jpg"
    }
  }, [_c('p', {
    staticClass: "page-text mb-6 mb-lg-20"
  }, [_vm._v("Over four decades of excellence in industrial automation and thousands of installations worldwide, Extrel process mass spectrometers provide the rugged stability and ease-of-use necessary for continuous operation in demanding manufacturing environments.")]), _c('p', {
    staticClass: "page-text mb-6 mb-lg-20"
  }, [_vm._v(" - Hydrocarbon Processing"), _c('br'), _vm._v(" - Syngas Manufacturing"), _c('br'), _vm._v(" - Metals Manufacturing"), _c('br'), _vm._v(" - Gas Purity ")]), _c('div', {
    staticClass: "mt-30 mt-md-60 mt-lg-80"
  }, [_c('v-btn', {
    staticClass: "justify-space-between",
    attrs: {
      "outlined": "",
      "tile": "",
      "width": "180",
      "color": "primary",
      "href": "https://www.extrel.com/",
      "target": "_blank"
    }
  }, [_c('span', [_vm._v("Web site")]), _c('v-icon', {
    attrs: {
      "size": "16"
    }
  }, [_vm._v("mdi-open-in-new")])], 1)], 1)])], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }